import React from 'react';

const FeaturesNG = ({active}) => {
  return (
    <div className={`tab-content key-features ${active === 'features' ? 'active' : null}`} id="key-features">
      <h3 className="title">Key Features</h3>

      <div className="d-md-flex justify-content-md-center align-items-md-start">
        <div className="features-item">
          <div className="icon">
            <img src="/images/v2/buyers/security.svg" alt="Security" />
          </div>
          <h4>Secure payment steps</h4>
          <p>
            When you initiate a payment using PayOnDelivery, your money gets securely held
            and released only when you receive and verify the item.
          </p>
        </div>

        <div className="features-item">
          <div className="icon">
            <img src="/images/v2/buyers/card-tick.svg" alt="Transfers" />
          </div>
          <h4>Fee transfer based on approval</h4>
          <p>
            PayOnDelivery is built with the latest payment protection technology. It gives you a complete
            control over the payment. You don’t pay until you get the delivery and have verified the item.
          </p>
        </div>

        <div className="features-item">
          <div className="icon">
            <img src="/images/v2/buyers/truck-tick.svg" alt="Delivery" />
          </div>
          <h4>Get delivery without leaving home</h4>
          <p>
            We bring the goods to you within 24h! If you don’t like the product, we’ll pick it up and return
            for you without any hassle. Our system is integrated with Gokada and delivery partners, so you can be
            assured that your item will be shipped safely and timely.
          </p>
        </div>
      </div>
    </div>
  )
}

export default FeaturesNG;
